import { IService } from '@rafterjs/di-autoloader';

export { IService };
